// useAngleAudioOrder.ts — envoie au microservice l'audio que doivent porter les angles de la multivue.
//
// Seule la régie qui DÉTIENT LE CONTRÔLE parle : le microservice ignore (en le journalisant) les
// ordres de pilotage des autres. L'ordre est envoyé à chaque changement, puis réaffirmé toutes les
// ANGLE_AUDIO_REASSERT_MS tant que « programme » est voulu : côté serveur il expire au bout d'une
// minute, pour qu'une régie qui plante ne laisse jamais les angles accrochés à un programme disparu.
// « own » n'a pas besoin d'être réaffirmé : c'est l'état par défaut du serveur.

import { useEffect } from 'react';

import {
  AngleAudioMode, ANGLE_AUDIO_REASSERT_MS, angleAudioMessage,
} from '../../../dataTypes/liveStreamManagment/angleAudio';

export function useAngleAudioOrder(
  mode    : AngleAudioMode,
  isHolder: boolean,
  wsRef   : { current: WebSocket | null },
  angles  : string[] = [],
): void {
  // Une clé de contenu : un tableau recréé à l'identique ne doit pas rouvrir l'effet (donc renvoyer l'ordre).
  const anglesKey = angles.join(',');
  useEffect(() => {
    if (!isHolder) return;
    const liste = anglesKey ? anglesKey.split(',') : [];
    const send = () => {
      const ws = wsRef.current;
      if (ws?.readyState === WebSocket.OPEN) ws.send(angleAudioMessage(mode, liste));
    };
    send();
    if (mode !== 'program') return;
    const id = window.setInterval(send, ANGLE_AUDIO_REASSERT_MS);
    return () => window.clearInterval(id);
  }, [mode, isHolder, wsRef, anglesKey]);
}
